// extracted by mini-css-extract-plugin
export default {"card":"AnchorEarnPromote_card__BNask","header":"AnchorEarnPromote_header__yfLke","footer":"AnchorEarnPromote_footer__YJuc-"};